import { Component } from '@angular/core';
import {User, UserProvider} from "../../../providers/user/user";
import {Response} from "../../../providers/response";
import {AvatarProvider} from "../../../providers/avatar/avatar";
import {TranslateService} from "@ngx-translate/core";
import {AuthProvider} from "../../../providers/auth/auth";
import {App, ModalController, NavController} from "ionic-angular";
import {ProfilePage} from "../profile/profile";
import {WelcomePage} from "../../welcome/welcome";
import {Storage} from "@ionic/storage";
import {EditProfileComponent} from "../profile/edit-profile/edit-profile.component";
import {NotificationsPage} from "../notifications/notifications";
import {PollPage} from "../poll/poll";
import {HomePage} from "../home/home";
import {RhDashboardPage} from "../_rh/dashboard/rh-dashboard";
import { RhDrivePage } from '../_rh/drive/rh-drive';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { RGPDPage } from '../rgpd/rgpd';

/**
 * Generated class for the MenuProfileComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
  selector: 'menu-profile',
  templateUrl: 'menu-profile.html'
})
export class MenuProfile {

  user: User;
  userId:string;
  avatarString:string = '';


  menuItems = [
    {img: 'assets/icons/profile-menu/profile.svg', text: this.translate.instant('menu-profile.account.profile'), component: ProfilePage},
    {img: 'assets/icons/profile-menu/notification.svg', text: this.translate.instant('menu-profile.account.notifications'), component: NotificationsPage},
    {img: 'assets/icons/profile-menu/surveys.svg', text: this.translate.instant('menu-profile.account.surveys'), component: PollPage},
    // {img: 'assets/icons/profile-menu/people.svg', text: this.translate.instant('menu-profile.account.friends'), component: NotificationsPage}, TODO
    {img: 'assets/icons/profile-menu/folder.svg', text: this.translate.instant('menu-profile.account.file-manager'), component: RhDrivePage},
    // {img: 'assets/icons/profile-menu/setting.svg', text: this.translate.instant('menu-profile.account.settings'), component: NotificationsPage} TODO
  ]

  constructor(private avatarProvider: AvatarProvider,
              private translate: TranslateService,
              private authProvider: AuthProvider,
              private userProvider: UserProvider,
              public navCtrl: NavController,
              public storageProvider: Storage,
              public app: App,
              private modalCtrl: ModalController,
              private iab: InAppBrowser,

  ) {
    this.userId = this.authProvider.user.user_id;
  }

  ngOnInit() {
    this.getData();

  }


  getData(): void {
    this.userProvider.get(this.userId).subscribe(
      (res: Response<User>) => {
        this.user = res.data;
        if (res.data.avatar_id) {
          this.avatarProvider.get(res.data.avatar_id).subscribe(
            (res) => {
              try {
                const avatar = res.data.avatar_content
                this.avatarProvider.avatarContent = avatar;
                this.avatarString = avatar;
              } catch (err) {
                console.log(err);
              }
            }
          );
        }
      },
      err => console.log(err)
    );
  }


  goToMyProfile() {
    this.navCtrl.push(ProfilePage, {})
      .then(() => {
        console.log('Welcome to profile');
      });
  }

  goToEditProfile() {
    let modalView = this.modalCtrl.create(EditProfileComponent, {user: this.user})
    modalView.onDidDismiss(() => {
      this.getData()
    })
    modalView.present().then(() => {});
  }

  logout(){
    this.storageProvider.remove('access_token').then(() => console.log('logout'))
    this.app.getRootNav().setRoot(WelcomePage)
      .then(() => {

      })
  }

  goTo(component) {
    this.modalCtrl.create(component).present();
  }

  goToRgpdDownload(){
    this.modalCtrl.create(RGPDPage).present();
  }

  goToCGU(){
    const browser = this.iab.create('https://teambuildr.fr/cgu', '_system', 'location=yes')
  }


  toggleTheme(event) {
    console.log(event);
    if(event.checked) {
      document.body.setAttribute('color-theme', 'dark');
    }
    else {
      document.body.setAttribute('color-theme', '');
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/menu-profile/menu-profile.ts